import React from 'react'
import Layout from '../Layout/Layout'

import { Link } from "react-router-dom";
const Digitalization_Emerging_Technology = () => {
  return (
      <Layout>
            <div className='uk-container'>
                <h2 className='light uk-text-bold  uk-margin-xlarge-top'>Digitalization/ Emerging Technology</h2>

                <div className='uk-grid'>
                    <div className='uk-width-1-2@s'>
                        <p className='light'>The digital transition presents an enormous force for good,
                             but its power must be carefully channeled by putting strategically vital
                            technologies into the right hands for the benefit of both people and the
                            planet. Technologies such as Artificial Intelligence (AI), machine
                            learning, and encryption must be consciously used to drive equitable 
                            growth and environmental sustainability. Moolu Venture Lab is dedicated
                             to ensuring this outcome by building the capacity of innovators and the
                              policy frameworks around them.</p>

                    <p className='light'>Moolu Venture Lab supports innovators through Entrepreneurial Education,
                         offering comprehensive, blended programs that include incubation and acceleration to 
                         sharpen their business skills and market readiness. In parallel, the Lab fosters 
                         Innovation by identifying and advancing breakthrough digital technologies through 
                         intensive, cutting-edge Research & Innovation activities. This focus ensures that
                          African solutions are technologically sound and globally competitive.</p>
                    </div>



                      <div className='uk-width-1-2@s'>
                             <p className='light'>The Lab drives Business Creation by actively scaling 
                                deep-tech ventures through its Open Innovation Factory. This Factory
                                 provides a critical mix of resources, including essential funding,
                                  hands-on mentoring, and strategic access to markets both within 
                                  Africa and globally. This approach is designed to transform 
                                  promising technologies into high-growth, sustainable enterprises..</p>

                         <p className='light'>Beyond direct venture support, Moolu Venture Lab undertakes
                             crucial Research to find context-specific solutions to Africa's most pressing 
                             problems. This research directly informs its Policy Briefs, which are used to 
                             generate recommendations and advocacy on the right strategic approaches for 
                             all stakeholders. These policy efforts ensure that the digital economy develops
                              inclusively and sustainably, achieving shared goals.</p>
                    </div>
                </div>


                  <div className='light uk-text-center uk-margin-large-top'>
                    <p>Find links to our research and incubation programs</p>
                  <p> Incubation Program:<Link to ="/Nextechczar_Incubation_Program"> Nextechczar Incubation Program </Link></p> 
                    
                    </div>

            <div className='uk-grid uk-margin-large-top'>
                 <div className='uk-width-1-2@s'>
                     <h4 className='uk-text-bold light'>Research:</h4>
                        <p><Link to ="/AI_low_resource">AI  Low-Resource Language Models for African</Link>  </p>
                         <p><Link to ="/advanced_generative_AI">Advanced Generative AI (GenAI) models for Improving Crop Productivity and Climate Resilience in Nigeria </Link>  </p>
                 </div>


                 <div className='uk-width-1-2@s'>
                        <h4 className='uk-text-bold light'>Policy Brief:</h4>
                        <p><Link to ="/national_generative_AI">National Generative AI Policy for Inclusive Innovation (Nigeria 2025–2030) </Link>  </p>
                         <p><Link to ="/data_Sovereignty">Data Sovereignty and Talent Sovereignty  </Link>  </p>
 
                 </div>
            </div>





            </div>
      </Layout>
  )
}

export default Digitalization_Emerging_Technology